import { render, staticRenderFns } from "./AddOrEditRoleDialog.vue?vue&type=template&id=53c4f76a&scoped=true"
import script from "./AddOrEditRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddOrEditRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditRoleDialog.vue?vue&type=style&index=0&id=53c4f76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4f76a",
  null
  
)

export default component.exports